<template>
  <!--自定义组件通常都写于modal中-->
  <a-modal visible @ok="handleOk" @cancel="handleCancel">
    <a-form layout="vertical">
      <ak-inputs v-model="data" :options="options" ref="input" />
    </a-form>
  </a-modal>
</template>
<script>
import NP from 'number-precision'
// import Json from './../../assets/json/schema.json'

export default {
  data () {
    return {
      data: {
        amount: this.record.amount,
        shipping: this.record.shipping,
        pricePerTon: this.record.pricePerTon,
        packid: this.record.packid.objectId,
        palletid: this.record.palletid.objectId,
        profit: this.record.profit
      },
      objectId: this.record.objectId,
      options: [
        {
          name: 'amount',
          note: '吨数',
          type: 'Number',
          validators: [
            (val) => val ? null : '吨数不可为空',
            (val) => {
              if (val <= 0) {
                return '请输入正确的吨数'
              }
            }
          ]
        },
        {
          name: 'shipping',
          note: '运费',
          type: 'Number',
          validators: [
            (val) => val ? null : '运费不可为空',
            (val) => {
              if (val <= 0) {
                return '请输入正确的运费'
              }
            }
          ]
        },
        {
          name: 'pricePerTon',
          note: '每吨运费',
          type: 'Number',
        },
        {
          name: 'packid',
          note: '包装',
          type: 'Pointer',
          targetClass: 'Pack'
        },
        {
          name: 'palletid',
          note: '托盘',
          type: 'Pointer',
          targetClass: 'Pallet'
        },
      ],
      tag: false
    }
  },
  methods: {
    // 计算利润
    async getProfit () {
      await this.$tkHelper.sleep(300)

      if (this.record.costPrice !== '' && this.data.amount !== '' && this.record.packid !== '' && this.record.palletid !== '' && this.record.sellingPrice !== '' && this.data.pricePerTon !== '' && this.record.clientCommission !== '') {
        if (this.record.shopManagementid.profitRatio1 === null || this.record.modelId.profitRatio2 === null || this.record.shopManagementid.amountRatio1 === null || this.record.modelId.amountRatio2 === null) {
          this.data.profit = null
        } else {
          let { data: res1 } = await this.$tkParse.get('/settings')
          let amountCommissionRadix = res1.amountCommission
          console.log(res1)
          let amountCommission = NP.round(NP.times(amountCommissionRadix, this.record.shopManagementid.amountRatio1, this.record.modelId.amountRatio2), 2)
          let orderSalaryP = NP.round(NP.divide(NP.times(NP.minus(this.record.sellingPrice, NP.times(this.record.taxRate, this.record.sellingPrice), this.data.pricePerTon, this.record.clientCommission, this.record.packid.price, this.record.palletid.price, this.record.costPrice), NP.times(this.record.shopManagementid.profitRatio1, this.record.modelId.profitRatio2, this.data.amount)), NP.plus(1, NP.times(this.record.shopManagementid.profitRatio1, this.record.modelId.profitRatio2, this.data.amount))), 2)
          console.log(this.record.taxRate, this.record.sellingPrice, this.data.pricePerTon, this.record.clientCommission, this.record.packid.price, this.record.palletid.price, this.record.costPrice, this.record.shopManagementid.profitRatio1, this.record.modelId.profitRatio2, this.data.amount,)
          let orderSalaryT = NP.round(NP.times(amountCommission, this.data.amount), 2)
          // let profitP = NP.round(NP.minus(NP.minus(this.record.sellingPrice, NP.times(this.record.sellingPrice, this.record.taxRate), this.data.pricePerTon, this.record.clientCommission, this.record.packid.price, this.record.palletid.price, orderSalaryP), this.record.costPrice), 2)
          // let profitT = NP.round(NP.minus(NP.minus(this.record.sellingPrice, NP.times(this.record.sellingPrice, this.record.taxRate), this.data.pricePerTon, this.record.clientCommission, this.record.packid.price, this.record.palletid.price, orderSalaryT), this.record.costPrice), 2)
          this.data.profit = NP.round(NP.minus(NP.times(NP.minus(this.record.sellingPrice, NP.times(this.record.sellingPrice, this.record.taxRate), this.record.clientCommission, this.record.packid.price, this.record.palletid.price, this.record.costPrice), this.data.amount), this.data.shipping, Math.max(orderSalaryP, orderSalaryT)), 2)
        }
      }
    },
    // 自动修正运费
    shippingRevise () {
      if (this.tag) {
        this.tag = false
        return
      }
      this.data.shipping = NP.round(NP.times(this.data.pricePerTon, this.data.amount), 2)
      this.$nextTick(() => {
        this.tag = false
      })
    },
    // 自动修正每吨运费
    pricePerTonRevise () {
      this.data.pricePerTon = NP.round(NP.divide(this.data.shipping, this.data.amount), 2)
      this.tag = true
      // let x = document.activeElement
      // console.log('活跃元素')
      // console.log(x)
      console.log('修正每吨运费')
    },
    async handleOk () {
      try {
        await this.getProfit()
        await this.$modelAjax.put('Order', this.objectId, this.data)
        this.$notification.success({
          message: '保存成功',
          description: '数据已保存'
        })
        this.vm.refresh()
        this.$emit('complete', 'cancel')
      } catch (e) {
        console.log(e)
        this.$notification.error({
          message: '网络错误',
          description: '网络错误'
        })
      }
    },
    handleCancel () {
      // this.vm.refresh()
      this.$emit('complete')
    }
  },
  created () {
    // this.options = this.model.fields
    this.unWatch0 = this.$watch(() => this.data.pricePerTon, this.shippingRevise)
    this.unWatch1 = this.$watch(() => this.data.amount, this.shippingRevise)
    // this.unWatch2 = this.$watch(() => this.data.amount, this.pricePerTonRevise)
    this.unWatch3 = this.$watch(() => this.data.shipping, this.pricePerTonRevise)
  },
  mounted () {
    console.log(this.record)
  },
  updated () {
  },
  // 你可以接收到以下props，这些与自定义callback的action参数完全一致
  props: {
    record: Object, // 当前行的数据
    vm: Object, // 触发这个action的组件对象，通常为modelTable或modelTree
    fields: Array, // 当前model的fields对象
    model: Object, // 当前model对象
    className: String, // 当前model的className
    modelName: String, // 当前model的名称
    category: String // 假如当前model显示为category格式，则会将当前的值传入
  },
}
</script>

<style>

</style>
